// import React, { useState, useEffect } from "react";
// import "../assets/css/GroupLoanForm.css";
// import axios from "axios";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { toast } from "react-toastify";

// const normalizeFrequency = (value = "") => {
//   const v = String(value).trim().toLowerCase();
//   if (["day", "days", "daily"].includes(v)) return "daily";
//   if (["week", "weeks", "weekly"].includes(v)) return "weekly";
//   if (["bi-weekly", "biweekly", "fortnightly", "fortnight"].includes(v))
//     return "bi-weekly";
//   if (["month", "months", "monthly"].includes(v)) return "monthly";
//   if (["quarter", "quarters", "quarterly"].includes(v)) return "quarterly";
//   if (
//     [
//       "half-yearly",
//       "half yearly",
//       "halfyearly",
//       "semiannual",
//       "semi-annual",
//     ].includes(v)
//   )
//     return "half-yearly";
//   if (["year", "years", "yearly", "annual"].includes(v)) return "yearly";
//   return "";
// };

// const FREQUENCY_MAP = {
//   daily: 365,
//   weekly: 52,
//   "bi-weekly": 26,
//   monthly: 12,
//   quarterly: 4,
//   "half-yearly": 2,
//   yearly: 1,
// };

// export default function GroupFixedLoanForm() {
//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ---------------- Static Data / Sync State ----------------
//   const [services, setServices] = useState([]);
//   const [groups, setGroups] = useState([]);
//   const [centers, setCenters] = useState([]);

//   // ---------------- State ----------------
//   const [loanType, setLoanType] = useState("");
//   const [loanScheme, setLoanScheme] = useState("");
//   const [availableSchemes, setAvailableSchemes] = useState([]);
//   const [selectedService, setSelectedService] = useState(null);
//   const [selectedCenter, setSelectedCenter] = useState(null);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [selectedGroupLeader, setSelectedGroupLeader] = useState(null);

//   const [loanAmount, setLoanAmount] = useState("");
//   const [loanTenure, setLoanTenure] = useState("");
//   const [loanEMIAmount, setLoanEMIAmount] = useState("");
//   const [loanInterest, setLoanInterest] = useState("");
//   const [loanPayable, setLoanPayable] = useState("");

//   const [formData, setFormData] = useState({
//     loanAppliedDate: "",
//     loanDisbursalMode: "",
//     groupLeaderRelation: "",
//     centerName: "",
//   });
//   const [customers, setCustomers] = useState([]);
//   const [submitStatus, setSubmitStatus] = useState("");
//   const [loadingg, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchCustomersData = async () => {
//       try {
//         setLoading(true);
//         const branchId = localStorage.getItem("userId");
//         const params = new URLSearchParams({
//           branchId,
//           superAdminId: profile.superAdminId,
//           limit: 1000,
//         });

//         const res = await axios.get(
//           `https://payyug.in/api/customers?${params.toString()}`,
//         );
//         setCustomers(res.data?.data || []);
//       } catch (error) {
//         toast.error("Failed to fetch customers");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (profile?.superAdminId) {
//       fetchCustomersData();
//     }
//   }, [profile?.superAdminId]);

//   const fetchServices = async () => {
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/premium-scheme/get-all?superAdminId=${profile?.superAdminId}`,
//       );
//       setServices(res?.data?.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };

//   const fetchCenters = async () => {
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&branchId=${profile?.branchId}&limit=10000`,
//       );
//       setCenters(res.data?.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };

//   const fetchGroups = async () => {
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter.id}&limit=10000`,
//       );
//       setGroups(res.data?.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };

//   useEffect(() => {
//     if (profile?.superAdminId) fetchServices();
//   }, [profile]);

//   useEffect(() => {
//     if (profile?.id) fetchCenters();
//   }, [profile]);

//   useEffect(() => {
//     if (selectedCenter?.id) {
//       fetchGroups();
//     } else {
//       setGroups([]);
//     }
//   }, [selectedCenter]);

//   // ---------------- Effects ----------------
//   useEffect(() => {
//     if (loanType) {
//       const schemes = services.filter((s) => s.serviceType === loanType && s.status.toLowerCase()==="active");
//       setAvailableSchemes(schemes);
//     } else {
//       setAvailableSchemes([]);
//       setLoanScheme("");
//       setSelectedService(null);
//     }
//   }, [loanType, services]);

//   useEffect(() => {
//     if (loanScheme) {
//       const service = services.find((s) => s.serviceName === loanScheme);
//       setSelectedService(service);
//     }
//   }, [loanScheme, services]);

//   const calculateLoanDetails = ({
//     principal,
//     tenure,
//     tenureType,
//     recoveryFrequency,
//     emi,
//   }) => {
//     const tenureFreq = normalizeFrequency(tenureType);
//     const recoveryFreq = normalizeFrequency(recoveryFrequency);

//     const tenurePerYear = FREQUENCY_MAP[tenureFreq];
//     const recoveryPerYear = FREQUENCY_MAP[recoveryFreq];

//     // Explicitly check for numeric validity, allowing zero checks securely
//     if (!principal || !tenure || !emi || !tenurePerYear || !recoveryPerYear) {
//       return null;
//     }

//     const installmentCount = Math.round(
//       (Number(tenure) * recoveryPerYear) / tenurePerYear,
//     );
//     const payable = Number(emi) * installmentCount;
//     const interest = payable - Number(principal);

//     return {
//       installmentCount,
//       payable: Number(payable.toFixed(2)),
//       interest: Number(Math.max(0, interest).toFixed(2)),
//     };
//   };

//   // Dynamic Interest and Payable calculation
//   useEffect(() => {
//     // Check lengths and raw string values to avoid truthy zero evaluations blocking execution
//     if (!loanAmount || !loanTenure || !loanEMIAmount || !selectedService) {
//       setLoanInterest("");
//       setLoanPayable("");
//       return;
//     }

//     const result = calculateLoanDetails({
//       principal: loanAmount,
//       tenure: loanTenure,
//       tenureType: selectedService?.tenureType || selectedService?.recoveryType,
//       recoveryFrequency: selectedService?.recoveryType,
//       emi: loanEMIAmount,
//     });

//     if (result) {
//       setLoanInterest(result.interest);
//       setLoanPayable(result.payable);
//     }
//   }, [loanAmount, loanTenure, loanEMIAmount, selectedService]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !selectedCenter ||
//       !selectedGroup ||
//       !selectedCustomer ||
//       !selectedGroupLeader ||
//       !selectedService ||
//       !loanAmount ||
//       !loanTenure ||
//       !loanEMIAmount
//     ) {
//       toast.warn("Please fill all required fields");
//       return;
//     }

//     const payload = {
//       superAdminId: profile.superAdminId,
//       branchId: profile.branchId,
//       centerId: selectedCenter.id,
//       centerName: selectedCenter.CenterName || "",
//       groupId: selectedGroup.id,
//       groupName: selectedGroup.groupname,
//       schemeId: selectedService.id,
//       memberId: selectedCustomer.id,
//       memberName: selectedCustomer.fullName,
//       officerId: profile.id,
//       officerName: profile.fullName,
//       groupLeaderId: selectedGroupLeader.id,
//       groupLeaderName: selectedGroupLeader.fullName,
//       loanType: "FIXED" || loanType,
//       loanAmount: Number(loanAmount), // Fixed: pull from primary standalone inputs
//       loanTenure: Number(loanTenure), // Fixed: pull from primary standalone inputs
//       loanEmiAmount: Number(loanEMIAmount),
//       loanInterest: Number(loanInterest),
//       loanPayable: Number(loanPayable),
//       loanRoi: selectedService.rateOfInterest,
//       loanRoiType: selectedService.roiType,
//       openingDate: formData.loanAppliedDate,
//       loanRecoveryFrequency: selectedService.recoveryType,
//       createdBy: profile.id,
//     };

//     try {
//       setSubmitStatus("loading");
//       await axios.post(
//         `https://payyug.in/api/group-loan/member/create`,
//         payload,
//       );
//       toast.success("Group loan applied successfully");
//       resetForm();
//     } catch (err) {
//       toast.error(err?.response?.data?.error || err?.response?.data?.message || "Submission failed");
//     } finally {
//       setSubmitStatus("");
//     }
//   };

//  const resetForm = () => {
//     setLoanType("");
//     setLoanScheme("");
//     setAvailableSchemes([]);

//     setSelectedService(null);

//     setSelectedCenter(null);
//     setSelectedGroup(null);
//     setSelectedCustomer(null);
//     setSelectedGroupLeader(null);

//     setGroups([]);

//     setLoanAmount("");
//     setLoanTenure("");

//     setLoanEMIAmount(0);
//     setLoanInterest(0);
//     setLoanPayable(0);

//     setFormData({
//         loanAmount: "",
//         loanTenure: "",
//         loanAppliedDate: "",
//         loanDisbursalMode: "",
//         groupLeaderRelation: "",
//         centerName: "",
//         groupName: "",
//         userId: "",
//     });
// };

//   return (
//     <div className="group-loan-form-container">
//       <h1>Group Fixed Loan Application Form</h1>
//       {loadingg && <p>Loading data...</p>}
//       <form
//         id="personal-loan-form"
//         className="group-loan-form-section"
//         onSubmit={handleSubmit}
//         noValidate
//       >
//         {/* Loan Options & Schemes */}
//         <section className="group-loan-form-inputs-section">
//           <h2>Group Loan Options & Schemes</h2>
//           <div className="group-loan-form-loan-options">
//             <div className="group-loan-form-input-groups">
//               <label htmlFor="loan-type">Group Loan Type</label>
//               <select
//                 id="loan-type"
//                 name="loanType"
//                 value={loanType}
//                 onChange={(e) => setLoanType(e.target.value)}
//                 required
//               >
//                 <option value="" disabled>
//                   Select Group Loan Type
//                 </option>
//                 {services
//                   .filter(
//                     (s) =>
//                       s.serviceType &&
//                       s.serviceType.toLowerCase().includes("fixed"),
//                   )
//                   .filter(
//                     (service, index, self) =>
//                       index ===
//                       self.findIndex(
//                         (t) => t.serviceType === service.serviceType,
//                       ),
//                   )
//                   .map((service) => (
//                     <option value={service.serviceType} key={service.id}>
//                       {service.serviceType}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label htmlFor="loan-scheme">Group Loan Scheme</label>
//               <select
//                 id="loan-scheme"
//                 name="loanScheme"
//                 value={loanScheme}
//                 onChange={(e) => setLoanScheme(e.target.value)}
//                 disabled={!availableSchemes.length}
//                 required
//               >
//                 <option value="" disabled>
//                   Select Scheme
//                 </option>
//                 {availableSchemes.map((s) => (
//                   <option key={s.serviceName} value={s.serviceName}>
//                     {s.serviceName}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </section>

//         {/* Loan Details */}
//         <section className="group-loan-form-inputs-section">
//           <h2>Group Loan Details</h2>
//           <div className="group-loan-form-details-grid">
//             <div className="group-loan-form-input-groups">
//               <label>Minimum Loan Amount</label>
//               <input
//                 type="number"
//                 value={selectedService?.minAmount || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Maximum Loan Amount</label>
//               <input
//                 type="number"
//                 value={selectedService?.maxAmount || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Group Loan Interest Rate (%)</label>
//               <input
//                 type="number"
//                 value={selectedService?.rateOfInterest || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>ROI Frequency</label>
//               <input
//                 type="text"
//                 value={selectedService?.roiFrequency || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>ROI Type</label>
//               <input
//                 type="text"
//                 value={selectedService?.roiType || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Recovery Frequency</label>
//               <input
//                 type="text"
//                 value={selectedService?.recoveryType || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Maximum Tenure</label>
//               <input
//                 type="text"
//                 value={selectedService?.maxTenure || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Loan Amount</label>
//               <input
//                 type="number"
//                 value={loanAmount}
//                 onChange={(e) => setLoanAmount(e.target.value)}
//                 placeholder="Enter Loan Amount"
//                 required
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Tenure</label>
//               <input
//                 type="number"
//                 value={loanTenure}
//                 onChange={(e) => setLoanTenure(e.target.value)}
//                 placeholder="Enter Tenure"
//                 required
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Loan EMI Amount</label>
//               <input
//                 type="number"
//                 value={loanEMIAmount}
//                 onChange={(e) => setLoanEMIAmount(e.target.value)}
//                 placeholder="Enter EMI Amount"
//                 required
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Loan Interest Amount</label>
//               <input value={loanInterest} readOnly placeholder="0.00" />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Total Payable Amount</label>
//               <input value={loanPayable} readOnly placeholder="0.00" />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label htmlFor="loanDisbursalMode">Loan Disbursal Mode</label>
//               <select
//                 id="loanDisbursalMode"
//                 name="loanDisbursalMode"
//                 value={formData.loanDisbursalMode || ""}
//                 onChange={handleChange}
//               >
//                 <option value="" disabled>
//                   Select Loan Disbursal Mode
//                 </option>
//                 {["Bank Transfer", "Cheque", "Cash"].map((o) => (
//                   <option key={o} value={o}>
//                     {o}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label htmlFor="loanAppliedDate">Group Loan Applied Date</label>
//               <input
//                 type="date"
//                 required
//                 id="loanAppliedDate"
//                 name="loanAppliedDate"
//                 value={formData.loanAppliedDate || ""}
//                 onChange={handleChange}
//               />
//             </div>
//           </div>
//         </section>

//         {/* Center & Group Selection */}
//         <section className="group-loan-form-inputs-section">
//           <div className="group-loan-form-input-groups full-width">
//             <label htmlFor="centerName">Select Center Name</label>
//             <select
//               id="centerName"
//               name="centerName"
//               value={selectedCenter?.id || ""}
//               onChange={(e) => {
//                 handleChange(e);
//                 const center = centers.find(
//                   (c) => c.id === Number(e.target.value),
//                 );
//                 setSelectedCenter(center || null);
//               }}
//             >
//               <option value="" disabled>
//                 Select Center Name
//               </option>
//               {centers.map((c) => (
//                 <option key={c.id} value={c.id}>
//                   {c.CenterName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="group-loan-form-input-groups extra-cls full-width">
//             <label htmlFor="groupName">Select Group Name</label>
//             <select
//               id="groupName"
//               name="groupName"
//               value={selectedGroup ? selectedGroup.id : ""}
//               onChange={(e) => {
//                 const group = groups.find(
//                   (g) => g.id === Number(e.target.value),
//                 );
//                 setSelectedGroup(group || null);
//               }}
//               disabled={!groups.length}
//             >
//               <option value="" disabled>
//                 Select Group Name
//               </option>
//               {groups.map((gn) => (
//                 <option key={gn.id} value={gn.id}>
//                   {gn.groupname} ({gn.groupcode})
//                 </option>
//               ))}
//             </select>
//           </div>
//         </section>

//         {/* Member Details */}
//         <section className="group-loan-form-inputs-section">
//           <h2>Member Details</h2>
//           <div className="group-loan-form-input-groups">
//             <label htmlFor="userId">Customer Name & ID</label>
//             <select
//               id="userId"
//               name="userId"
//               value={selectedCustomer ? selectedCustomer.id : ""}
//               onChange={(e) => {
//                 const customer = customers.find(
//                   (c) => c.id === Number(e.target.value),
//                 );
//                 setSelectedCustomer(customer || null);
//               }}
//             >
//               <option value="">Select Customer</option>
//               {customers.map((c) => (
//                 <option key={c.id} value={c.id}>
//                   {c.fullName} ({c.userId})
//                 </option>
//               ))}
//             </select>
//           </div>

//           {selectedCustomer && (
//             <div className="group-loan-form-details-grid">
//               <div className="group-loan-form-input-groups">
//                 <label>Full Name</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.fullName || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>Mobile Number</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.mobileNumber || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>Aadhaar Number</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.aadhaarNumber || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>PAN Number</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.panNumber || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>Bank Account Number</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.bankAccount || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>IFSC</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.bankIFSC || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>Guardian Name</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.guardianName || ""}
//                   readOnly
//                 />
//               </div>
//               <div className="group-loan-form-input-groups">
//                 <label>Address</label>
//                 <input
//                   type="text"
//                   value={selectedCustomer.address || ""}
//                   readOnly
//                 />
//               </div>
//             </div>
//           )}
//         </section>

//         {/* Group Leader Details */}
//         <section className="group-loan-form-inputs-section">
//           <h2>Group Leader Details</h2>
//           <div className="group-loan-form-details-grid">
//             <div className="group-loan-form-input-groups">
//               <label htmlFor="groupLeaderName">Group Leader Name</label>
//               <select
//                 id="groupLeaderName"
//                 name="groupLeaderName"
//                 value={selectedGroupLeader ? selectedGroupLeader.id : ""}
//                 onChange={(e) => {
//                   const leader = customers.find(
//                     (c) => c.id === Number(e.target.value),
//                   );
//                   setSelectedGroupLeader(leader || null);
//                 }}
//               >
//                 <option value="">Select Group Leader</option>
//                 {customers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.fullName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Mobile Number</label>
//               <input
//                 type="text"
//                 value={selectedGroupLeader?.mobileNumber || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label>Aadhar Number</label>
//               <input
//                 type="text"
//                 value={selectedGroupLeader?.aadhaarNumber || ""}
//                 readOnly
//               />
//           </div>

//             <div className="group-loan-form-input-groups">
//               <label>Pan Number</label>
//               <input
//                 type="text"
//                 value={selectedGroupLeader?.panNumber || ""}
//                 readOnly
//               />
//             </div>

//             <div className="group-loan-form-input-groups">
//               <label htmlFor="groupLeaderRelation">
//                 Relation with Applicant
//               </label>
//               <input
//                 type="text"
//                 id="groupLeaderRelation"
//                 name="groupLeaderRelation"
//                 placeholder="Enter Relation with Applicant"
//                 value={formData.groupLeaderRelation || ""}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>
//         </section>

//         <div className="group-loan-form-submit-wrapper">
//           <button
//             type="submit"
//             className="group-loan-form-submit-btn"
//             aria-label="Apply for loan"
//             disabled={submitStatus === "loading"}
//           >
//             {submitStatus === "loading" ? "Submitting..." : "Apply"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }





import React, { useState, useEffect } from "react";
import "../assets/css/GroupLoanForm.css";
import axios from "axios";
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const normalizeFrequency = (value = "") => {
  const v = String(value).trim().toLowerCase();
  if (["day", "days", "daily"].includes(v)) return "daily";
  if (["week", "weeks", "weekly"].includes(v)) return "weekly";
  if (["bi-weekly", "biweekly", "fortnightly", "fortnight"].includes(v))
    return "bi-weekly";
  if (["month", "months", "monthly"].includes(v)) return "monthly";
  if (["quarter", "quarters", "quarterly"].includes(v)) return "quarterly";
  if (
    [
      "half-yearly",
      "half yearly",
      "halfyearly",
      "semiannual",
      "semi-annual",
    ].includes(v)
  )
    return "half-yearly";
  if (["year", "years", "yearly", "annual"].includes(v)) return "yearly";
  return "";
};

const FREQUENCY_MAP = {
  daily: 365,
  weekly: 52,
  "bi-weekly": 26,
  monthly: 12,
  quarterly: 4,
  "half-yearly": 2,
  yearly: 1,
};


// Custom styling for react-select matching your UI
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    height: "40px",
    minHeight: "40px",
    borderRadius: "6px",
    borderColor: state.isDisabled
      ? "#e2e8f0"
      : state.isFocused
      ? "#2563eb"
      : "#cbd5e1",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(37, 99, 235, 0.15)" : "none",
    fontSize: "14px",
    backgroundColor: state.isDisabled ? "#f8fafc" : "#ffffff",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: state.isDisabled
        ? "#e2e8f0"
        : state.isFocused
        ? "#2563eb"
        : "#94a3b8",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "40px",
    padding: "0 12px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    color: "#0f172a",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#94a3b8" : "#0f172a",
    fontSize: "14px",
    fontWeight: "500",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#cbd5e1" : "#64748b",
    fontSize: "14px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "40px",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: "8px",
    color: state.isDisabled ? "#cbd5e1" : "#64748b",
    "&:hover": {
      color: state.isDisabled ? "#cbd5e1" : "#334155",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "8px",
    color: "#94a3b8",
    "&:hover": {
      color: "#ef4444",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "6px",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    marginTop: "4px",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    padding: "10px 12px",
    backgroundColor: state.isSelected
      ? "#2563eb"
      : state.isFocused
      ? "#eff6ff"
      : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#1e293b",
    cursor: "pointer",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export default function GroupFixedLoanForm() {
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ---------------- Static Data / Sync State ----------------
  const [services, setServices] = useState([]);
  const [groups, setGroups] = useState([]);
  const [centers, setCenters] = useState([]);

  // ---------------- State ----------------
  const [loanType, setLoanType] = useState("");
  const [loanScheme, setLoanScheme] = useState("");
  const [availableSchemes, setAvailableSchemes] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedGroupLeader, setSelectedGroupLeader] = useState(null);

  const [loanAmount, setLoanAmount] = useState("");
  const [loanTenure, setLoanTenure] = useState("");
  const [loanEMIAmount, setLoanEMIAmount] = useState("");
  const [loanInterest, setLoanInterest] = useState("");
  const [loanPayable, setLoanPayable] = useState("");

  const [formData, setFormData] = useState({
    loanAppliedDate: "",
    loanDisbursalMode: "",
    groupLeaderRelation: "",
    centerName: "",
  });
  const [customers, setCustomers] = useState([]);
  const [submitStatus, setSubmitStatus] = useState("");
  const [loadingg, setLoading] = useState(false);

  useEffect(() => {
    const fetchCustomersData = async () => {
      try {
        setLoading(true);
        const branchId = localStorage.getItem("userId");
        const params = new URLSearchParams({
          branchId,
          superAdminId: profile.superAdminId,
          limit: 1000,
        });

        const res = await axios.get(
          `https://payyug.in/api/customers?${params.toString()}`,
        );
        setCustomers(res.data?.data || []);
      } catch (error) {
        toast.error("Failed to fetch customers");
      } finally {
        setLoading(false);
      }
    };

    if (profile?.superAdminId) {
      fetchCustomersData();
    }
  }, [profile?.superAdminId]);

  const fetchServices = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/premium-scheme/get-all?superAdminId=${profile?.superAdminId}`,
      );
      setServices(res?.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&branchId=${profile?.branchId}&limit=10000`,
      );
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter.id}&limit=10000`,
      );
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  useEffect(() => {
    if (profile?.superAdminId) fetchServices();
  }, [profile]);

  useEffect(() => {
    if (profile?.id) fetchCenters();
  }, [profile]);

  useEffect(() => {
    if (selectedCenter?.id) {
      fetchGroups();
    } else {
      setGroups([]);
    }
  }, [selectedCenter]);

  // ---------------- Effects ----------------
  useEffect(() => {
    if (loanType) {
      const schemes = services.filter((s) => s.serviceType === loanType && s.status.toLowerCase()==="active");
      setAvailableSchemes(schemes);
    } else {
      setAvailableSchemes([]);
      setLoanScheme("");
      setSelectedService(null);
    }
  }, [loanType, services]);

  useEffect(() => {
    if (loanScheme) {
      const service = services.find((s) => s.serviceName === loanScheme);
      setSelectedService(service);
    }
  }, [loanScheme, services]);

  const calculateLoanDetails = ({
    principal,
    tenure,
    tenureType,
    recoveryFrequency,
    emi,
  }) => {
    const tenureFreq = normalizeFrequency(tenureType);
    const recoveryFreq = normalizeFrequency(recoveryFrequency);

    const tenurePerYear = FREQUENCY_MAP[tenureFreq];
    const recoveryPerYear = FREQUENCY_MAP[recoveryFreq];

    // Explicitly check for numeric validity, allowing zero checks securely
    if (!principal || !tenure || !emi || !tenurePerYear || !recoveryPerYear) {
      return null;
    }

    const installmentCount = Math.round(
      (Number(tenure) * recoveryPerYear) / tenurePerYear,
    );
    const payable = Number(emi) * installmentCount;
    const interest = payable - Number(principal);

    return {
      installmentCount,
      payable: Number(payable.toFixed(2)),
      interest: Number(Math.max(0, interest).toFixed(2)),
    };
  };

  // Dynamic Interest and Payable calculation
  useEffect(() => {
    // Check lengths and raw string values to avoid truthy zero evaluations blocking execution
    if (!loanAmount || !loanTenure || !loanEMIAmount || !selectedService) {
      setLoanInterest("");
      setLoanPayable("");
      return;
    }

    const result = calculateLoanDetails({
      principal: loanAmount,
      tenure: loanTenure,
      tenureType: selectedService?.tenureType || selectedService?.recoveryType,
      recoveryFrequency: selectedService?.recoveryType,
      emi: loanEMIAmount,
    });

    if (result) {
      setLoanInterest(result.interest);
      setLoanPayable(result.payable);
    }
  }, [loanAmount, loanTenure, loanEMIAmount, selectedService]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedCenter ||
      !selectedGroup ||
      !selectedCustomer ||
      !selectedGroupLeader ||
      !selectedService ||
      !loanAmount ||
      !loanTenure ||
      !loanEMIAmount
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    const payload = {
      superAdminId: profile.superAdminId,
      branchId: profile.branchId,
      centerId: selectedCenter.id,
      centerName: selectedCenter.CenterName || "",
      groupId: selectedGroup.id,
      groupName: selectedGroup.groupname,
      schemeId: selectedService.id,
      memberId: selectedCustomer.id,
      memberName: selectedCustomer.fullName,
      officerId: profile.id,
      officerName: profile.fullName,
      groupLeaderId: selectedGroupLeader.id,
      groupLeaderName: selectedGroupLeader.fullName,
      loanType: "FIXED" || loanType,
      loanAmount: Number(loanAmount), // Fixed: pull from primary standalone inputs
      loanTenure: Number(loanTenure), // Fixed: pull from primary standalone inputs
      loanEmiAmount: Number(loanEMIAmount),
      loanInterest: Number(loanInterest),
      loanPayable: Number(loanPayable),
      loanRoi: selectedService.rateOfInterest,
      loanRoiType: selectedService.roiType,
      openingDate: formData.loanAppliedDate,
      loanRecoveryFrequency: selectedService.recoveryType,
      createdBy: profile.id,
    };

    try {
      setSubmitStatus("loading");
      await axios.post(
        `https://payyug.in/api/group-loan/member/create`,
        payload,
      );
      toast.success("Group loan applied successfully");
      resetForm();
    } catch (err) {
      toast.error(err?.response?.data?.error || err?.response?.data?.message || "Submission failed");
    } finally {
      setSubmitStatus("");
    }
  };

 const resetForm = () => {
    setLoanType("");
    setLoanScheme("");
    setAvailableSchemes([]);

    setSelectedService(null);

    setSelectedCenter(null);
    setSelectedGroup(null);
    setSelectedCustomer(null);
    setSelectedGroupLeader(null);

    setGroups([]);

    setLoanAmount("");
    setLoanTenure("");

    setLoanEMIAmount(0);
    setLoanInterest(0);
    setLoanPayable(0);

    setFormData({
        loanAmount: "",
        loanTenure: "",
        loanAppliedDate: "",
        loanDisbursalMode: "",
        groupLeaderRelation: "",
        centerName: "",
        groupName: "",
        userId: "",
    });
};


// 1. Center Options
const centerOptions = centers.map((c) => ({
  value: c.id,
  label: c.CenterName,
  rawData: c,
}));

// 2. Group Options
const groupOptions = groups.map((g) => ({
  value: g.id,
  label: `${g.groupname}, ${g.groupcode}`,
  rawData: g,
}));

// 3. Customer Options
const customerOptions = customers.map((c) => ({
  value: c.id,
  label: `${c.fullName} (${c.userId})`,
  rawData: c,
}));

// 4. Group Leader Options
const groupLeaderOptions = customers.map((c) => ({
  value: c.id,
  label: c.fullName,
  rawData: c,
}));

  return (
    <div className="group-loan-form-container">
      <h1>Group Fixed Loan Application Form</h1>
      {loadingg && <p>Loading data...</p>}
      <form
        id="personal-loan-form"
        className="group-loan-form-section"
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Loan Options & Schemes */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Loan Options & Schemes</h2>
          <div className="group-loan-form-loan-options">
            <div className="group-loan-form-input-groups">
              <label htmlFor="loan-type">Group Loan Type</label>
              <select
                id="loan-type"
                name="loanType"
                value={loanType}
                onChange={(e) => setLoanType(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Group Loan Type
                </option>
                {services
                  .filter(
                    (s) =>
                      s.serviceType &&
                      s.serviceType.toLowerCase().includes("fixed"),
                  )
                  .filter(
                    (service, index, self) =>
                      index ===
                      self.findIndex(
                        (t) => t.serviceType === service.serviceType,
                      ),
                  )
                  .map((service) => (
                    <option value={service.serviceType} key={service.id}>
                      {service.serviceType}
                    </option>
                  ))}
              </select>
            </div>

            <div className="group-loan-form-input-groups">
              <label htmlFor="loan-scheme">Group Loan Scheme</label>
              <select
                id="loan-scheme"
                name="loanScheme"
                value={loanScheme}
                onChange={(e) => setLoanScheme(e.target.value)}
                disabled={!availableSchemes.length}
                required
              >
                <option value="" disabled>
                  Select Scheme
                </option>
                {availableSchemes.map((s) => (
                  <option key={s.serviceName} value={s.serviceName}>
                    {s.serviceName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        {/* Loan Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Loan Details</h2>
          <div className="group-loan-form-details-grid">
            <div className="group-loan-form-input-groups">
              <label>Minimum Loan Amount</label>
              <input
                type="number"
                value={selectedService?.minAmount || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Maximum Loan Amount</label>
              <input
                type="number"
                value={selectedService?.maxAmount || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Group Loan Interest Rate (%)</label>
              <input
                type="number"
                value={selectedService?.rateOfInterest || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>ROI Frequency</label>
              <input
                type="text"
                value={selectedService?.roiFrequency || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>ROI Type</label>
              <input
                type="text"
                value={selectedService?.roiType || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Recovery Frequency</label>
              <input
                type="text"
                value={selectedService?.recoveryType || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Maximum Tenure</label>
              <input
                type="text"
                value={selectedService?.maxTenure || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Loan Amount</label>
              <input
                type="number"
                value={loanAmount}
                onChange={(e) => setLoanAmount(e.target.value)}
                placeholder="Enter Loan Amount"
                required
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Tenure</label>
              <input
                type="number"
                value={loanTenure}
                onChange={(e) => setLoanTenure(e.target.value)}
                placeholder="Enter Tenure"
                required
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Loan EMI Amount</label>
              <input
                type="number"
                value={loanEMIAmount}
                onChange={(e) => setLoanEMIAmount(e.target.value)}
                placeholder="Enter EMI Amount"
                required
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Loan Interest Amount</label>
              <input value={loanInterest} readOnly placeholder="0.00" />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Total Payable Amount</label>
              <input value={loanPayable} readOnly placeholder="0.00" />
            </div>

            <div className="group-loan-form-input-groups">
              <label htmlFor="loanDisbursalMode">Loan Disbursal Mode</label>
              <select
                id="loanDisbursalMode"
                name="loanDisbursalMode"
                value={formData.loanDisbursalMode || ""}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Loan Disbursal Mode
                </option>
                {["Bank Transfer", "Cheque", "Cash"].map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </div>

            <div className="group-loan-form-input-groups">
              <label htmlFor="loanAppliedDate">Group Loan Applied Date</label>
              <input
                type="date"
                required
                id="loanAppliedDate"
                name="loanAppliedDate"
                value={formData.loanAppliedDate || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </section>

        {/* Center & Group Selection */}
        <section className="group-loan-form-inputs-section">
          <div className="group-loan-form-input-groups full-width">
            <label htmlFor="centerName">Select Center Name</label>
             <Select
      id="centerName"
      name="centerName"
      options={centerOptions}
      value={
        selectedCenter
          ? { value: selectedCenter.id, label: selectedCenter.CenterName }
          : null
      }
      onChange={(selectedOption) => {
        const center = selectedOption ? selectedOption.rawData : null;
        setSelectedCenter(center);
        setSelectedGroup(null); // Reset group on center change

        handleChange({
          target: {
            name: "centerName",
            value: selectedOption ? selectedOption.value : "",
          },
        });
      }}
      placeholder="Select Center Name"
      isClearable
      isSearchable
      styles={customSelectStyles}
      menuPortalTarget={document.body}
    />
          </div>

          <div className="group-loan-form-input-groups extra-cls full-width">
            <label htmlFor="groupName">Select Group Name</label>
             <Select
      id="groupName"
      name="groupName"
      options={groupOptions}
      value={
        selectedGroup
          ? {
              value: selectedGroup.id,
              label: `${selectedGroup.groupname}, ${selectedGroup.groupcode}`,
            }
          : null
      }
      onChange={(selectedOption) => {
        const group = selectedOption ? selectedOption.rawData : null;
        setSelectedGroup(group);
      }}
      placeholder={
        selectedCenter ? "Select Group Name" : "Select Center First"
      }
      isDisabled={!selectedCenter}
      isClearable
      isSearchable
      styles={customSelectStyles}
      menuPortalTarget={document.body}
    />
          </div>
        </section>

        {/* Member Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Member Details</h2>
          <div className="group-loan-form-input-groups">
            <label htmlFor="userId">Customer Name & ID</label>
            <Select
    id="userId"
    name="userId"
    options={customerOptions}
    value={
      selectedCustomer
        ? {
            value: selectedCustomer.id,
            label: `${selectedCustomer.fullName} (${selectedCustomer.userId})`,
          }
        : null
    }
    onChange={(selectedOption) => {
      const customer = selectedOption ? selectedOption.rawData : null;
      setSelectedCustomer(customer);
    }}
    placeholder="Select Customer"
    isClearable
    isSearchable
    styles={customSelectStyles}
    menuPortalTarget={document.body}
  />
          </div>

          {selectedCustomer && (
            <div className="group-loan-form-details-grid">
              <div className="group-loan-form-input-groups">
                <label>Full Name</label>
                <input
                  type="text"
                  value={selectedCustomer.fullName || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>Mobile Number</label>
                <input
                  type="text"
                  value={selectedCustomer.mobileNumber || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>Aadhaar Number</label>
                <input
                  type="text"
                  value={selectedCustomer.aadhaarNumber || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>PAN Number</label>
                <input
                  type="text"
                  value={selectedCustomer.panNumber || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>Bank Account Number</label>
                <input
                  type="text"
                  value={selectedCustomer.bankAccount || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>IFSC</label>
                <input
                  type="text"
                  value={selectedCustomer.bankIFSC || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>Guardian Name</label>
                <input
                  type="text"
                  value={selectedCustomer.guardianName || ""}
                  readOnly
                />
              </div>
              <div className="group-loan-form-input-groups">
                <label>Address</label>
                <input
                  type="text"
                  value={selectedCustomer.address || ""}
                  readOnly
                />
              </div>
            </div>
          )}
        </section>

        {/* Group Leader Details */}
        <section className="group-loan-form-inputs-section">
          <h2>Group Leader Details</h2>
          <div className="group-loan-form-details-grid">
            <div className="group-loan-form-input-groups">
              <label htmlFor="groupLeaderName">Group Leader Name</label>
              <Select
    id="groupLeaderName"
    name="groupLeaderName"
    options={groupLeaderOptions}
    value={
      selectedGroupLeader
        ? {
            value: selectedGroupLeader.id,
            label: selectedGroupLeader.fullName,
          }
        : null
    }
    onChange={(selectedOption) => {
      const customer = selectedOption ? selectedOption.rawData : null;
      setSelectedGroupLeader(customer);
    }}
    placeholder="Select Group Leader"
    isClearable
    isSearchable
    styles={customSelectStyles}
    menuPortalTarget={document.body}
  />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Mobile Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.mobileNumber || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label>Aadhar Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.aadhaarNumber || ""}
                readOnly
              />
          </div>

            <div className="group-loan-form-input-groups">
              <label>Pan Number</label>
              <input
                type="text"
                value={selectedGroupLeader?.panNumber || ""}
                readOnly
              />
            </div>

            <div className="group-loan-form-input-groups">
              <label htmlFor="groupLeaderRelation">
                Relation with Applicant
              </label>
              <input
                type="text"
                id="groupLeaderRelation"
                name="groupLeaderRelation"
                placeholder="Enter Relation with Applicant"
                value={formData.groupLeaderRelation || ""}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </section>

        <div className="group-loan-form-submit-wrapper">
          <button
            type="submit"
            className="group-loan-form-submit-btn"
            aria-label="Apply for loan"
            disabled={submitStatus === "loading"}
          >
            {submitStatus === "loading" ? "Submitting..." : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
}
